'use client';

import { Box, Container, Fade } from '@mui/material';
import { useIsMobile } from '@qb/frontend/hooks/mediaQueries';
import { Widget } from '@/shared/Constants';
import { PartDisplayParams } from '@/shared/classes/SPSPageComponentParams/PartDisplayParams';
import { TenantConfig } from '@/shared/types/controllers/sps/SPSAppControllerTypes';
import { PartDisplayDataResponse } from '@/shared/types/controllers/sps/SPSPartControllerTypes';
import { TrustBoxBottomLinks } from './TrustBoxBottomLinks';
import { TrustBoxPriceDetails } from './TrustBoxPriceDetails/TrustBoxPriceDetails';
import { TrustBoxTopLinks } from './TrustBoxTopLinks';
import { useIsTrustBoxPriceDetailsVisible } from './hooks/useIsTrustBoxPriceDetailsVisible';
const NAVBAR_HEIGHT = 0;
type TrustBoxProps = Pick<PartDisplayDataResponse, 'part' | 'publicQtyAndPrice' | 'spPartPageSetting'> & {
  tenantConfig: TenantConfig;
  partDisplayParams: PartDisplayParams;
};
export const TrustBox = ({
  tenantConfig,
  part,
  publicQtyAndPrice,
  partDisplayParams,
  spPartPageSetting
}: TrustBoxProps) => {
  const isMobile = useIsMobile();
  const {
    sidebarRef,
    isVisible: isSidebarBoxVisible
  } = useIsTrustBoxPriceDetailsVisible();
  if (isMobile) {
    return <>
        <TrustBoxPriceDetails tenantConfig={tenantConfig} part={part} publicQtyAndPrice={publicQtyAndPrice} spPartPageSetting={spPartPageSetting} />
        <TrustBoxTopLinks partDisplayParams={partDisplayParams} />
      </>;
  }
  const trustBoxTopBar = <Fade in>
      <Box sx={{
      bgcolor: 'common.white',
      position: 'fixed',
      top: Widget.HORIZONTAL_STYLE_NAVBAR_DESKTOP_HEIGHT,
      left: 0,
      right: 0,
      zIndex: 'appBar',
      boxShadow: 12
    }}>
        <Container sx={{
        py: 1
      }}>
          <TrustBoxPriceDetails tenantConfig={tenantConfig} isNavbarStyleOnDesktop={true} part={part} publicQtyAndPrice={publicQtyAndPrice} spPartPageSetting={spPartPageSetting} />
        </Container>
      </Box>
    </Fade>;
  return <>
      {isSidebarBoxVisible ? null : trustBoxTopBar}
      <Box sx={{
      borderStyle: 'solid',
      borderWidth: 8,
      borderColor: 'common.backgroundColor',
      position: 'sticky',
      top: NAVBAR_HEIGHT
    }} data-sentry-element="Box" data-sentry-source-file="TrustBox.tsx">
        <div ref={sidebarRef}>
          <TrustBoxPriceDetails tenantConfig={tenantConfig} part={part} publicQtyAndPrice={publicQtyAndPrice} spPartPageSetting={spPartPageSetting} data-sentry-element="TrustBoxPriceDetails" data-sentry-source-file="TrustBox.tsx" />
        </div>
        <TrustBoxTopLinks partDisplayParams={partDisplayParams} data-sentry-element="TrustBoxTopLinks" data-sentry-source-file="TrustBox.tsx" />
        <TrustBoxBottomLinks data-sentry-element="TrustBoxBottomLinks" data-sentry-source-file="TrustBox.tsx" />
      </Box>
    </>;
};